import React, { Component } from 'react'
import './index.less'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  jumpToRoomNew,
  inject,
  observer,
  jumpToWallet,
  jumpToTab,
  jumpToGames
} from '../../../helper/devTools.js'
import { isRtl } from 'src/helper/tool'

import { jumpToFriend } from '../../../helper/webviewFun'

import dsbridge from 'dsbridge'

import { history } from 'src/core/router'

import Message from '../../../component/Message'
import LoadingComp from '../../../component/LoadingComp'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.welfareStore = this.props.store.register('activity/welfare')
  }
  state = {
    userInfo: {},
    lang: {},
    messageTxt: "",
    isDraw: false,
    canDraw: true,
    DrawResultShow: false,
    dailyList: [],
    gameList: [],
    loading: false,
    dailyCount: 0,
    dailyCountStatus: 0,
    rechargeCount: 0,
    rechargeCountStatus: 0,
    rewardImg: "",
    rewardName: "",
    num: 0,
    language:'en',
    getShow: false,
    getShowList: [],
    canGetNum: 1
  }

  async initLang() {
    let language = await getlang(this.props.location.query.language)
    let langStore = this.welfareStore.data.welfareLang
    await this.setState({
      lang: setlang(language, langStore),
      language: language,
    })
    
    setDocumentTitle(this.state.lang.title)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    return uid
  }

  async getDaily() {
    let dailyList = await this.welfareStore.apiGetDailyTasksList()
    this.setState({
      dailyList: dailyList && dailyList.res
    })
  }
  async getGame() {
    let gameList = await this.welfareStore.apiGetGameTasksList()
    this.setState({
      gameList: gameList && gameList.res
    })
  }
  async getCount() {
    let count = await this.welfareStore.getDrawCount(1)
    let count2 = await this.welfareStore.getDrawCount(2)
    this.setState({
      dailyCount: count && count.res,
      dailyCountStatus: count && count.code,
      rechargeCount: count2 && count2.res,
      rechargeCountStatus: count2 && count2.code,
    })
  }

  async initList() {
    this.welfareStore.getRandomTopThirty()
    this.welfareStore.randomLudoGid()
    await this.getDaily()
    await this.getGame()
    await this.getCount()
  }

  async componentDidMount() {
    try {
      this.setState({
        loading: true
      })
      let uid = await this.initUid()
      await this.initLang()
      await this.RunOnStart(uid)
      await this.initList()
    } catch (error) {
      console.error(error)
      this.refs.msg.show(error)
    } finally {
      this.setState({
        loading: false
      })
    }
    // 返回页面时回调
    dsbridge.register('onWebViewShow', () => {
      this.initList()
    })
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    try {
      this.setState({
        uid: uid
      })
      let getUserInfo = await this.welfareStore.GetUserInfoWeb(uid)
      if (getUserInfo && getUserInfo.code == 0) {
        this.setState({
          userInfo: getUserInfo.res
        })
      }
    } catch (error) {
      console.error(error)
      this.refs.msg.show("error")
    }
  }

  /**
   * @description 返回字体阴影颜色
   */
  gameTaskType(type) {
    if (type == 1) {
      return "#842FFF"
    }
    if (type == 2) {
      return "#E8751C"
    }
    if (type == 3) {
      return "#23B300"
    }
    if (type == 4) {
      return "#127CEB"
    }
  }

  /**
   * @description 返回任务底部背景
   */
  gameTaskBgType(type) {
    if (type == 1) {
      return "/img/activity/welfare/t1_bg.png"
    }
    if (type == 2) {
      return "/img/activity/welfare/t2_bg.png"
    }
    if (type == 3) {
      return "/img/activity/welfare/t3_bg.png"
    }
    if (type == 4) {
      return "/img/activity/welfare/t4_bg.png"
    }
  }


  async receiveTask(status, tId, list, canGetNum) {
    this.setState({
      getShowList: list,
      canGetNum
    })
    if (status == 1) {
      let getResult = await this.welfareStore.getDailyTasksReward(tId)
      console.log(getResult)
      if (getResult && getResult.res == 0) {
        this.initList()
        // this.refs.msg.show(this.state.lang.getSuc)
        this.setState({
          getShow: true
        })
      }
      if (getResult && getResult.res == 1) {
        this.refs.msg.show(this.state.lang.tdone)
      }
      if (getResult && getResult.res == 2) {
        this.refs.msg.show(this.state.lang.tundone)
      }
    }
    if (status == 2) {
      this.refs.msg.show(this.state.lang.tdone)
    }
  }

  /**
   * @description 处理游戏任务点击事件
   */
  async handleGameTask(status, type, tId, list, canGetNum) {
    if (status == 0) {
      console.log("去完成")
      if (type == 1) {
        // let gid = await this.welfareStore.getRandomTopThirty()
        jumpToGames(type, this.welfareStore.data.gid)
      }
      if (type == 2) {
        // let gid = await this.welfareStore.getRandomTopThirty()
        jumpToGames(type, this.welfareStore.data.gid)
      }
      if (type == 3) {
        // let gid = await this.welfareStore.getRandomTopThirty()
        jumpToGames(type, this.welfareStore.data.gid)
      }
      if (type == 4) {
        // let ludoGid = await this.welfareStore.randomLudoGid()
        // let gid = await this.welfareStore.getRandomTopThirty()
        // let goGid = 0
        // goGid = ludoGid == 0 ? gid : ludoGid
        // jumpToRoomNew(goGid)
        jumpToGames(5, this.welfareStore.data.ludoGid)
      }
    }
    this.receiveTask(status, tId, list, canGetNum)
  }

  /**
   * @description 处理每日任务点击事件
   */
  async handleDailyTask(status, type, tId, list, canGetNum) {
    if (status == 0) {
      if (type == 1) {
        jumpToFriend()
      }
      if (type == 2) {
        let gid = await this.welfareStore.getRandomTopThirty()
        jumpToGames(4, gid)
      }
      if (type == 3) {
        let gid = await this.welfareStore.getRandomOnlineMic()
        jumpToRoomNew(gid)
      }
      if (type == 4) {
        jumpToTab("tabMoment")
      }
    }
    this.receiveTask(status, tId, list, canGetNum)
  }


  /**
   * @description 获取进度条背景颜色
   */
  gameTaskTypeProgBg(type) {
    if (type == 1) {
      return "#4E00C0"
    }
    if (type == 2) {
      return "#B24D02"
    }
    if (type == 3) {
      return "#1C9B0E"
    }
    if (type == 4) {
      return "#3671F2"
    }
  }

  /**
   * @description 获取进度条边框颜色
   */
  gameTaskTypeProgBor(type) {
    if (type == 1) {
      return "#BE84FF"
    }
    if (type == 2) {
      return "#FFD366"
    }
    if (type == 3) {
      return "#B2FF78"
    }
    if (type == 4) {
      return "#85CCFF"
    }
  }

  /**
  * @description 抽奖
  */
  async handleDraw(type) {
    let drawType = type == "daily" ? 1 : 2
    // 关闭阀门
    this.setState({
      canDraw: false
    })
    // 多次点击返回
    if (!(this.state.canDraw)) {
      return
    }

    if (type == "daily") {
      if (this.state.dailyCount > 0) {
        let drawRes = await this.welfareStore.apiDrawReward(drawType)
        let count = await this.welfareStore.getDrawCount(drawType)
        console.log(drawRes)
        this.setState({
          isDraw: true, // 抽奖动画
          rewardImg: drawRes && drawRes.res && drawRes.res.image,  // 中奖图片
          num: drawRes && drawRes.res && drawRes.res.num,           // 中奖数量
          rewardName: drawRes && drawRes.res && drawRes.res.name,
          dailyCount: count && count.res,  // 更改数量
          dailyCountStatus: count && count.code
        })
      }
      else if (this.state.dailyCountStatus == 81) {
        this.refs.msg.show(this.state.lang.drawDesc)
        this.setState({
          canDraw: true
        })
        return
      }
      else if (this.state.dailyCountStatus == 82) {
        this.setState({
          rewardImg: "",
          rewardName: "",
          num: "",
          canDraw: true,
          DrawResultShow: true
        })
        return
      }
      else {
        this.setState({
          canDraw: true
        })
        return
      }


      setTimeout(() => {
        this.setState({
          isDraw: false,
          canDraw: true,
          DrawResultShow: true
        })
      }, 4000);
    }

    if (type == "recharge") {
      if (this.state.rechargeCount > 0) {
        let drawRes = await this.welfareStore.apiDrawReward(drawType)
        let count = await this.welfareStore.getDrawCount(drawType)
        console.log(drawRes)
        this.setState({
          isDraw: true,
          rewardImg: drawRes && drawRes.res && drawRes.res.image,
          num: drawRes && drawRes.res && drawRes.res.num,
          rewardName: drawRes && drawRes.res && drawRes.res.name,
          rechargeCount: count && count.res,
          rechargeCountStatus: count && count.code,
        })
      } else {
        this.refs.msg.show(this.state.lang.noDraw)
        this.setState({
          canDraw: true
        })
        return
      }


      setTimeout(() => {
        this.setState({
          isDraw: false,
          canDraw: true,
          DrawResultShow: true
        })
      }, 4000);
    }
  }

  goRechargePage() {
    console.log("前往app充值页面")
    jumpToWallet()
  }

  goBenefitsPage() {
    history.push("/activity/goldRubyRecharge")
  }


  // ---------组件---------

  TabComp = () => {
    return (
      <div className="center-tab-box">
        {false &&<div className="center-tab">
          <div className={`tab-item ${this.welfareStore.data.tabStatus == 1 && "tab-item-active"}`} onClick={() => this.welfareStore.setTabStatus(1)}>{this.state.lang.day}</div>
          <div className={`tab-item ${this.welfareStore.data.tabStatus == 2 && "tab-item-active"}`} onClick={() => this.welfareStore.setTabStatus(2)}>{this.state.lang.recharge}</div>
        </div>}
      </div>
    )
  }

  gameTaskItemList(item, k) {
    return (
      <div className="g-t-item" style={{ backgroundImage: `url(${this.gameTaskBgType(item.type)})` }} key={k}>
        <div className="left">
          <img src={item.icon} alt="" />
        </div>
        <div className="middle">
          <div className="title" style={{ textShadow: `0 0 0.05rem ${this.gameTaskType(item.type)}` }}>{item.title}</div>
          <div className="prog-box">
            <div
              className="prog"
              style={{
                border: `0.01rem solid ${this.gameTaskTypeProgBor(item.type)}`,
                background: `${this.gameTaskTypeProgBg(item.type)}`
              }}>
              <div className="prog-current" style={{ transform: `translateX(${(-100 + (item.current / item.target) * 100)}%)` }}></div>
            </div>
            <div className="prog-target">
              <span>{item.current}</span>
              <span>/</span>
              <span>{item.target}</span>
            </div>
          </div>
        </div>
        <div className="right">
          {
            item && item.gainList.map((el, key) => {
              return (
                <div className="gold" key={key}>
                  <img src={el.icon} alt="" />
                  <div className="num">+{el.value}</div>
                </div>
              )
            })
          }
          {/* <div className="get-btn"> */}
            {/* {item.status == 0 && (<div className="go" onClick={() => { this.handleGameTask(item.status, item.type, item.taskid, item.gainList, item.canGetNum) }}>{this.state.lang.go}</div>)} */}
            {item.status == 1 && (<div className="get-btn"><div className="get" onClick={() => { this.handleGameTask(item.status, item.type, item.taskid, item.gainList, item.canGetNum) }}>{this.state.lang.get}</div></div>)}
            {item.status == 2 && (<div className="get-btn"><div className="done" onClick={() => { this.handleGameTask(item.status, item.type, item.taskid, item.gainList, item.canGetNum) }}>{this.state.lang.done}</div></div>)}
          {/* </div> */}
        </div>
      </div>
    )
  }

  dailyTaskItemList(i, k) {
    console.log('dailyTaskItemList',this.state.lang)
    return (
      <div className="d-t-item" key={k}>
        <div className="left">
          <img src={i.icon} alt="" />
        </div>
        <div className="middle">
          <div className="task">
            <span className='txt'>{i.title}</span>
            <span className='pro'>
              (
              <span>{i.current}</span>
              <span>/</span>
              <span>{i.target}</span>
              )
            </span>
          </div>
          <div className="rw">
            {
              i && i.gainList && i.gainList.map((i2, k2) => {
                return (
                  <span key={k2}>
                    <img src={i2.icon} alt="" />
                    +{i2.value}
                  </span>
                )
              })
            }
          </div>
        </div>
        <div
          className="right"
          onClick={() => { this.handleDailyTask(i.status, i.type, i.taskid, i.gainList, i.canGetNum) }}
          style={{ display: `${i.status == 0 ? "flex" : "none"}` }}>
          {this.state.lang.go}
        </div>
        <div
          className="get"
          onClick={() => { this.handleDailyTask(i.status, i.type, i.taskid, i.gainList, i.canGetNum) }}
          style={{ display: `${i.status == 1 ? "flex" : "none"}` }}>
          {this.state.lang.get}
        </div>
        <div
          className="done"
          onClick={() => { this.handleDailyTask(i.status, i.type, i.taskid, i.gainList, i.canGetNum) }}
          style={{ display: `${i.status == 2 ? "flex" : "none"}` }}>
          <span>
            {this.state.lang.done}
          </span>
        </div>
      </div>
    )
  }

  GameTaskComp = (props) => {
    let { tabStatus } = props

    return (
      <div className="center-game-task-wrapper" style={{ display: `${tabStatus == 1 ? "block" : "none"}` }}>
        <div className="center-game-task-box">
          <div className="g-t-title">
            <div className="txt">{this.state.lang.gt}</div>
            <img src="/img/activity/welfare/game_icon.png" alt="" />
          </div>
          {this.state.gameList && this.state.gameList.map((item, k) => this.gameTaskItemList(item, k))}
        </div>
      </div>
    )
  }

  DailyTaskComp = (props) => {
    let { tabStatus } = props
    // status 0 表示当前是无法领取状态      显示GO
    // status 1 表示当前是可领取状态        显示领取
    // status 2 表示已经全部领取           显示已完成

    return (
      <div className="center-daily-task-wrapper" style={{ display: `${tabStatus == 1 ? "block" : "none"}` }}>
        <div className="center-daily-task-box">
          <div className="d-t-title">
            <div className="txt">{this.state.lang.dt}</div>
            <img src="/img/activity/welfare/task_icon.png" />
          </div>
          {this.state.dailyList && this.state.dailyList.map((i, k) => this.dailyTaskItemList(i, k))}
        </div>
      </div>
    )
  }

  RechargeComp = (props) => {
    let { tabStatus } = props
    let list = [
      {
        title: this.state.lang.dr,
        price: 10,
        gold: 2000
      },
      {
        title: this.state.lang.dr,
        price: 20,
        gold: 4100
      },
      {
        title: this.state.lang.dr,
        price: 30,
        gold: 6300
      },
      {
        title: this.state.lang.dr,
        price: 50,
        gold: 11000
      },
      {
        title: this.state.lang.dr,
        price: 100,
        gold: 24000
      }
    ]
    return ( false &&
      <div className="recharge-main-wrapper" style={{ display: `${tabStatus == 2 ? "block" : "none"}` }}>
        <div className="rc-title">
          <div className="txt">{this.state.lang.rw}</div>
        </div>
        {
          list.map((i, k) => {
            return (
              <div className="rc-item" key={k}>
                <div className="left"></div>
                <div className="middle">{i.title}${i.price}</div>
                <div className="right">
                  <span>+{i.gold}</span>
                  <img src="/img/activity/welfare/rw1.png" alt="" />
                </div>
              </div>
            )
          })
        }
        <div className="recharge-btn" onClick={() => { this.goRechargePage() }}>{this.state.lang.recharge}</div>
      </div>
    )
  }

  RechargeBannerComp = (props) => {
    let { tabStatus } = props

    return (
      <div className="recharge-banner" style={{ display: `${tabStatus == 2 ? "block" : "none"}` }} onClick={() => { this.goBenefitsPage() }}>
        {this.state.language == 'ar' && <img src="/img/activity/eid-activities/recharge_ar.png" alt="" />}
        {this.state.language == 'tr' && <img src="/img/activity/eid-activities/recharge_tr.png" alt="" />}
        {this.state.language != 'tr' && this.state.language != 'ar' && <img src="/img/activity/eid-activities/recharge_en.png" alt="" />}
      </div>
    )
  }

  RaffleComp = (props) => {
    const { tabStatus } = props
    const type = tabStatus == 1 ? "daily" : "recharge"
    const list = [
      '/img/activity/welfare/rw1.png',
      '/img/activity/welfare/rw2.png',
      '/img/activity/welfare/rw3.png',
    ]
    return ( false &&
      <div className={`raffle-main-wrapper`}>
        <div className="r-title">
          <p style={{ display: `${type == "daily" ? "block" : "none"}` }}>
            {this.state.lang.drawDesc}
          </p>
          <p style={{ display: `${type == "recharge" ? "block" : "none"}` }}>
            <span style={{ display: `${this.state.language == "zh" ? "block" : "none"}` }}>
              每充值<span style={{ color: "#8739FF" }}>50000</span>金币，可抽奖一次
            </span>
            <span style={{ display: `${this.state.language == "en" ? "block" : "none"}` }}>
              For every <span style={{ color: "#8739FF" }}>50000</span> coins recharged, you can draw a prize once
            </span>
            <span style={{ display: `${this.state.language == "ar" ? "block" : "none"}` }}>
              مقابل كل <span style={{ color: "#8739FF" }}>50000</span> كوينز من الشحن، يمكنك أن تأخد اليانصيب لمرة .
            </span>
          </p>
        </div>
        <div className="r-content">
          <div className={`light-bor ${this.state.isDraw && "light-bor-ani"}`}></div>
          {
            list.map((i, k) => {
              return (
                <div className="r-item" key={k}>
                  <div className="r-light">
                    <img src={i} alt="" />
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className="draw-btn" onClick={() => { this.handleDraw(type) }}>{this.state.lang.draw}</div>
      </div>
    )
  }

  DrawResultComp = () => {
    return (
      <div className="draw-result-outer" style={{ display: `${this.state.DrawResultShow ? "flex" : "none"}` }}>
        <div className="draw-result">
          {/* <div className="close" onClick={() => { this.setState({ DrawResultShow: false }) }}>
            <img src="/img/activity/welfare/close.png" alt="" />
          </div> */}
          <div className="title">{this.state.lang.rwsend}</div>

          <div className="content" style={{ display: `${this.state.rewardImg && this.state.num && this.state.rewardName ? "flex" : "none"}` }}>
            <div className="img-outer">
              <img src={this.state.rewardImg} alt="" />
            </div>
            <span>{this.state.rewardName}&nbsp;+{this.state.num}</span>
          </div>

          {
            this.state.rewardImg == "" && this.state.num == "" && this.state.dailyCountStatus == 82 && (
              <div className="content">
                {this.state.lang.hadGet}
              </div>
            )
          }
          <div className="yes" onClick={() => { this.setState({ DrawResultShow: false }) }}>OK</div>
        </div>
      </div>
    )
  }

  getResultComp = () => {
    return (
      <div
        className={`get-result-content`}
        style={{ display: `${this.state.getShow ? "flex" : "none"}` }}>
        <div className="get-result">
          <div className="title">
            {this.state.lang.rwsend}
          </div>
          <div className="content" style={{ display: `flex` }}>
            {
              this.state.getShowList.map((i, k) => {
                return (
                  <div className="item" key={k}>
                    <div className="pic" style={{ backgroundImage: `url(${i.icon})` }}></div>
                    <span>+{i.value * this.state.canGetNum}</span>
                  </div>
                )
              })
            }
          </div>
          <div className="yes" onClick={() => { this.setState({ getShow: false }) }}>OK</div>
        </div>
      </div>
    )
  }

  render() {
    console.log(this.state.lang,'this.state.lang')
    return (
      <div className={`welfare-main-container ${isRtl(this.state.language) && "arlang"}`}>

        <div className="none" style={{ display: "none" }}>
          <img src="/img/activity/welfare/light.png" alt="" />
          <img src="/img/activity/welfare/t1_bg.png" alt="" />
          <img src="/img/activity/welfare/t2_bg.png" alt="" />
          <img src="/img/activity/welfare/t3_bg.png" alt="" />
          <img src="/img/activity/welfare/t4_bg.png" alt="" />
        </div>

        <Message ref="msg" />

        <div className="welfare-main-content">
          <img className='banner' src="/img/activity/welfare/banner.png" alt="" />
          {/* 标题 */}
          <div className="center-title">{this.state.lang.title}</div>

          {/* tab栏 */}
          <this.TabComp />

          {/* 游戏任务 */}
          <this.GameTaskComp tabStatus={this.welfareStore.data.tabStatus} />

          {/* 每日任务 */}
          <this.DailyTaskComp tabStatus={this.welfareStore.data.tabStatus} />

          {/* 充值banner */}
          <this.RechargeBannerComp tabStatus={this.welfareStore.data.tabStatus} />

          {/* 充值列表 */}
          <this.RechargeComp tabStatus={this.welfareStore.data.tabStatus} />

          {/* 每日抽奖 */}
          <this.RaffleComp tabStatus={this.welfareStore.data.tabStatus} />
        </div>

        {/* 抽奖结果 */}
        <this.DrawResultComp />

        {/* 领取结果 */}
        <this.getResultComp />

      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/pages/activity/welfare/index.js